import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../i18n';

const LANG_KEY = 'sirus_lang';

export function useLanguage() {
  const { i18n } = useTranslation();

  const setLanguage = useCallback((code) => {
    i18n.changeLanguage(code);
    localStorage.setItem(LANG_KEY, code);
  }, [i18n]);

  return {
    language:  i18n.language,
    setLanguage,
    languages: LANGUAGES,
  };
}
